/**
 * Legacy URL: /app/worldcup/groups/member-profile (matched [groupId] before).
 * Redirects to /app/worldcup/member-profile with the same query params.
 */

import { Redirect, useLocalSearchParams } from 'expo-router';

export default function LegacyGroupsMemberProfileRedirect() {
  const params = useLocalSearchParams<Record<string, string | string[]>>();
  // Old path always meant “from squads”; preserve wcTab if already set.
  const next = { ...params, wcTab: params.wcTab ?? 'groups' };
  return <Redirect href={{ pathname: '/app/worldcup/member-profile', params: next }} />;
}
